module.exports = __webpack_public_path__ + "img/blue_105.c5c4bdab.png";